
interface Translations {
    [key: string]: { name: string, icon: string }
}

const occasionsTranslations: Translations = {
    "platform.occasions.default.birthday.name": {
        name: "Birthday",
        icon: "https://res.cloudinary.com/perkbox/image/upload/v1574417971/deals-light-ui/shared/occasions/png/birthday_1_0.png"
    },
    "platform.occasions.default.engaged.name": {
        name: "Engaged",
        icon: "https://res.cloudinary.com/perkbox/image/upload/v1574417970/deals-light-ui/shared/occasions/png/engaged_1_0.png"
    },
    "platform.occasions.default.longService.name": {
        name: "Long Service",
        icon: "https://res.cloudinary.com/perkbox/image/upload/v1574417970/deals-light-ui/shared/occasions/png/service_1_0.png"
    },
    "platform.occasions.default.newBaby.name": {
        name: "New Baby",
        icon: "https://res.cloudinary.com/perkbox/image/upload/v1574417970/deals-light-ui/shared/occasions/png/new_baby_1_0.png"
    },
    "platform.occasions.default.newHouse.name": {
        name: "New House",
        icon: "https://res.cloudinary.com/perkbox/image/upload/v1574417970/deals-light-ui/shared/occasions/png/new_house_1_0.png"
    },
    "platform.occasions.default.staffEntertainment.name": {
        name: "Staff entertainment",
        icon: "https://res.cloudinary.com/perkbox/image/upload/v1574417970/deals-light-ui/shared/occasions/png/staff_entertainment_2_0.png"
    },
    "platform.occasions.default.teamLunch.name": {
        name: "Team Lunch",
        icon: "https://res.cloudinary.com/perkbox/image/upload/v1574417970/deals-light-ui/shared/occasions/png/team_lunch_1_0.png"
    },
    "platform.occasions.default.wedding.name": {
        name: "Wedding",
        icon: "https://res.cloudinary.com/perkbox/image/upload/v1574417970/deals-light-ui/shared/occasions/png/wedding_1_0.png"
    }
}

export default occasionsTranslations
